import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  Route,
  Router,
  UrlTree,
} from '@angular/router';
import { LoginService } from '@app/shared/services/Login.service';
import { Observable } from 'rxjs';
import jwt_decode from 'jwt-decode';
import { JwtData } from '@app/shared/interfaces/jwt-data';
import { NzNotificationService } from 'ng-zorro-antd/notification';
@Injectable({
  providedIn: 'root',
})
export class IsAuthorized implements CanActivate {
  onLoad = true;
  constructor(
    private router: Router,
    private notification: NzNotificationService
  ) {}
  canActivate(route: ActivatedRouteSnapshot) {
    const token = localStorage.getItem('token');
    if (token == null) {
      this.router.navigate(['/auth/login']);
      return false;
    }
    const tokendata = new JwtData(jwt_decode(token));
    const role = tokendata.role;
    const roles = route?.data['role'];
    if (roles == null) {
      return true;
    } else {
      const allowedRoles = roles.split(',');
      const IsAuthorized = allowedRoles.includes(role);
      if (!IsAuthorized) {
        this.notification.error(
          'Not Authorized',
          'You are not authorized to navigate to this page'
        );
        this.router.navigate(['/home']);
        return false;
      }
      return true;
    }
  }
}
